<div class="logout-confirmation">
  <div class="logout-confirmation__icon">
    <span class="odilo-icon">switch_on_off</span>
  </div>

  <div class="logout-confirmation__text">
    <h2>{{ 'logout.title' | translate }}</h2>
    <p>{{ 'logout.text' | translate }}</p>
  </div>
</div>
